import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

interface NewTemplateTileProps {
  onClick: () => void;
}

export function NewTemplateTile({ onClick }: NewTemplateTileProps) {
  const { t } = useTranslation('projectTemplates');

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-border p-3 text-muted-foreground transition-colors hover:border-primary/50 hover:text-primary"
      data-testid="project-templates-new-tile"
    >
      <Plus className="size-6" />
      <span className="text-sm font-medium">{t('gallery.newTemplateTile')}</span>
    </button>
  );
}
